import { APIClient } from '../helpers/api_helper';
const AxiosClient = new APIClient()
const login = payload => AxiosClient.post('/login',payload);
export {
  login,
}